<template>

  <ToastDialog :title="toastTitle" :message="toastMessage" :error="toastError" />

  <div class="question-view p-4">

    <!-- Header: titolo + pulsante Salva -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1 class="mb-0">Nuovo Quesito</h1>
      <!--<button class="btn btn-primary px-4" @click="saveQuestion" :disabled="!isFormValid">
        <i class="bi bi-floppy me-2"></i> Salva
      </button>
      <button class="btn btn-primary px-4" @click="saveQuestion" :disabled="!isFormValid">
        <i class="bi bi-envelope me-2"></i> Invia
      </button>-->
    </div>

    <div class="card p-4 mb-4">

      <!-- DIV Istruzioni -->
      <div class="mb-4 p-3"
        style="font-size: 0.9em; background-color: #fff; border: 0px solid #dee2e6; border-radius: 0.25rem; line-height: 1.2;">
        <p>
          Per l'invio dei quesiti al Servizio supporto giuridico l'utente deve compilare il campo
          <span class="fst-italic">"Oggetto"</span> posto in basso ed il campo
          <span class="fst-italic">"Testo del quesito"</span>, descrivendone sinteticamente il contenuto.
        </p>
        <p>
          Nel caso in cui il quesito riguardi tematiche afferenti appalti PNRR e PNC, flaggare l'apposita voce.
          Il sistema genera e assegna automaticamente al quesito un codice identificativo univoco.
          Le risposte ai quesiti elaborate dal Servizio saranno inoltrate all'indirizzo di posta elettronica che
          l'utente
          ha indicato in fase di registrazione.
        </p>
        <p>
          Le risposte verranno successivamente asseverate dall'Unità Operativa di Coordinamento (UOC), e pubblicate
          nell'apposita banca dati accessibile liberamente.
        </p>
        <p class="text-decoration-underline">
          Prima dell'asseverazione e successiva pubblicazione sulla piattaforma del Servizio, le risposte non rivestono
          carattere "ufficiale" e non possono essere considerate definitive. Pertanto,
          hanno carattere strettamente riservato, non possono essere utilizzate al di fuori del caso specifico oggetto
          del
          quesito, nè divulgate in alcuna forma prima della relativa pubblicazione.
        </p>
        <p>
          I quesiti, strettamente legati all'ambito applicativo del servizio, dovranno essere posti in maniera specifica
          e
          concisa, rispettando il limite dei 2000 caratteri. Le risposte mirano ad avere portata generale, si chiede
          pertanto agli utenti di non riportare dati riguardanti gli operatori economici coinvolti e/o riferimenti
          relativi alla specifica procedura di gara.
        </p>
        <p class="text-decoration-underline fw-bold">
          Gli utenti del Servizio sono responsabili della riservatezza del contenuto delle risposte.
        </p>
      </div>
    </div>

    <!-- Form Quesito -->
    <form @submit.prevent="saveQuestion">

      <!--<div class="mb-3 row">
        <div class="col-4">
          <label class="form-label">Argomenti</label>
          <select class="form-select" @change="addTopic($event)">
            <option value="">-- Seleziona un argomento --</option>
            <option v-for="topic in availableTopics" :key="topic.id" :value="topic.id">
              {{ topic.title }}
            </option>
          </select>

          <div class="mt-2">
            <span v-for="(topicId, index) in question.topics" :key="topicId" class="badge bg-primary me-1">
              {{ getTopicName(topicId) }}
              <button type="button" class="btn-close btn-close-white btn-sm ms-1" @click="removeTopic(index)"></button>
            </span>
          </div>
        </div>
      </div>-->
      <div class="mb-3 row">
        <div class="col-4">
          <label class="form-label">Argomenti</label>
          <template v-if="!readonly">
            <div class="dropdown">
              <button class="btn btn-light border text-dark w-100 d-flex justify-content-between align-items-center"
                type="button" data-bs-toggle="dropdown">
                <span>{{ selectedTopicsLabel }}</span>
              </button>

              <ul class="dropdown-menu p-2" style="max-height: 250px; overflow-y: auto; min-width: 250px;">
                <!-- Input di ricerca interna -->
                <li class="mb-2 px-2">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text bg-white"><i class="bi bi-search"></i></span>
                    <input type="text" class="form-control" placeholder="Cerca..." v-model="topicSearch" />
                  </div>
                </li>

                <!-- Lista filtrata -->
                <li v-for="topic in filteredTopics" :key="topic.id" class="form-check">
                  <input class="form-check-input" type="checkbox" :id="'topic-' + topic.id" :value="topic.id"
                    v-model="question.topics" />
                  <label class="form-check-label ms-2" :for="'topic-' + topic.id">{{ topic.title }}</label>
                </li>
              </ul>
            </div>
          </template>
          <template v-else>
            <div class="mt-2">
              <span v-for="topicId in question.topics" :key="topicId" class="badge bg-secondary me-1">
                {{ getTopicName(topicId) }}
              </span>
            </div>
          </template>

          <!--<div class="mt-2">
            <span v-for="(topicId, index) in question.topics" :key="topicId" class="badge bg-primary me-1">
              {{ getTopicName(topicId) }}
              <button type="button" class="btn-close btn-close-white btn-sm ms-1" @click="removeTopic(index)"></button>
            </span>
          </div>-->
          <div class="mt-2 d-flex flex-column">
            <span v-for="(topicId, index) in question.topics" :key="topicId"
              class="badge bg-primary mb-1 align-self-start">
              {{ getTopicName(topicId) }}
              <button type="button" class="btn-close btn-close-white btn-sm ms-1" @click="removeTopic(index)"></button>
            </span>
          </div>

        </div>

        <div class="col-4">
          <label class="form-label">Legislazione</label>
          <template v-if="!readonly">
            <div class="dropdown">
              <button class="btn btn-light border text-dark dropdown-toggle w-100 text-start" type="button"
                data-bs-toggle="dropdown">
                {{ selectedLegislationLabel }}
              </button>
              <ul class="dropdown-menu p-2" style="max-height: 250px; overflow-y: auto;">
                <li v-for="legislation in legislations" :key="legislation.id" class="form-check">
                  <input class="form-check-input" type="radio" :id="'legislation-' + legislation.id"
                    :value="legislation.id" v-model="question.legislation_id" />
                  <label class="form-check-label ms-2" :for="'legislation-' + legislation.id">
                    {{ legislation.title }}
                  </label>
                </li>
              </ul>
            </div>
          </template>
          <template v-else>
            <p class="form-control-plaintext">{{ getLegislationTitle(question.legislation_id) || '—' }}</p>
          </template>
        </div>

        <div class="col-4">
          <label class="form-label">Articolo</label>
          <template v-if="!readonly">
            <div class="dropdown">
              <button class="btn btn-light border text-dark dropdown-toggle w-100 text-start text-truncate"
                type="button" data-bs-toggle="dropdown" :title="selectedArticlesLabel">
                {{ selectedArticlesLabel }}
              </button>
              <ul class="dropdown-menu p-2" style="max-height: 250px; overflow-y: auto;">
                <li class="mb-2 px-2">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text bg-white"><i class="bi bi-search"></i></span>
                    <input type="text" class="form-control" placeholder="Cerca..." v-model="articleSearch" />
                  </div>
                </li>
                <li v-for="article in filteredArticles" :key="article.id" class="form-check">
                  <input class="form-check-input" type="checkbox" :id="'article-' + article.id" :value="article.id"
                    v-model="question.articles" />
                  <label class="form-check-label ms-2" :for="'article-' + article.id">{{ article.versions[0].title
                    }}</label>
                </li>
              </ul>

              <div class="mt-2 d-flex flex-column">
                <span v-for="(articleId, index) in question.articles" :key="articleId"
                  class="badge bg-primary mb-1 align-self-start badge-wrap">
                  {{ getArticleTitle(articleId) }}
                  <button type="button" class="btn-close btn-close-white btn-sm ms-1"
                    @click="removeArticle(index)"></button>
                </span>
              </div>
            </div>
          </template>
          <template v-else>
            <p class="form-control-plaintext">{{ selectedArticleLabel || '—' }}</p>
          </template>
        </div>
      </div>


      <!-- Oggetto del quesito -->

      <div class="mb-3">
        <label class="form-label">Oggetto del quesito <small class="text-muted ms-2" style="font-size: 0.85em;">(max {{
          maxObjectLength }} caratteri)</small></label>
        <template v-if="!readonly">
          <input type="text" class="form-control" v-model="question.object" :maxlength="maxObjectLength"
            placeholder="Inserisci l'oggetto" required />
          <small v-if="question.object.length > 0" class="text-muted d-block mt-1" style="font-size: 0.85em;">
            Caratteri rimanenti: {{ remainingObjectChars }}
          </small>
        </template>
        <template v-else>
          <p class="form-control-plaintext">{{ question.object }}</p>
        </template>
      </div>

      <!-- Testo del quesito -->

      <div class="mb-3">
        <label class="form-label">Testo del quesito <small class="text-muted ms-2 fs-7">
            (<strong>max {{ maxTextLength }} caratteri</strong>, quesiti di lunghezza superiore non saranno presi in
            considerazione)
          </small></label>
        <template v-if="!readonly">
          <textarea class="form-control" :class="{ 'text-area-scroll': question.text.length > 1000 }"
            v-model="question.text" :maxlength="maxTextLength" rows="8"
            placeholder="Inserisci il testo del quesito"></textarea>
          <small v-if="question.text.length > 0" class="text-muted d-block mt-1" style="font-size: 0.85em;">
            Caratteri rimanenti: {{ remainingTextChars }}
          </small>
        </template>
        <template v-else>
          <div class="p-2 border rounded bg-light" style="white-space: pre-wrap;">
            {{ question.text }}
          </div>
        </template>
      </div>

      <div class="text-center mt-4">
        <button type="submit"  class="btn btn-primary px-4" :disabled="!isFormValid">
          <i class="bi bi-envelope me-2"></i> Invia
        </button>
      </div>

      <!--<div class="mb-3">
        <label class="form-label d-block mb-2">Commenti</label>

        <div v-for="(comment, index) in question.comments" :key="index" class="input-group mb-2">
          <input type="text" class="form-control" v-model="question.comments[index]" placeholder="Commento" />
          <button class="btn btn-outline-danger" type="button" @click="removeComment(index)">
            ✖
          </button>
        </div>

        <button class="btn btn-primary mt-2" type="button" @click="addComment">
          + Aggiungi commento
        </button>
      </div>-->
    </form>

  </div>
</template>

<script>
import ToastDialog from '../../../components/common/ToastDialog.vue';
import BreadcrumbElement from '../../../components/common/BreadcrumbElement.vue';
import ModalView from '../../../components/common/ModalView.vue';
import toastable from '../../../mixins/toastable';

export default {
  name: 'QuestionView',
  mixins: [toastable],
  components: {
    ToastDialog,
    BreadcrumbElement,
    ModalView
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      question: {
        object: '',
        text: '',
        comments: [],
        topics: [],
        legislation_id: null,
        articles: []
      },
      legislations: [],
      maxObjectLength: 120,
      maxTextLength: 1500,
      showSuccessModal: false,
      toastTitle: '',
      toastMessage: '',
      toastError: false,
      errors: null,
      successMessage: null,
      availableTopics: [],
      availableArticles: [],
      topicSearch: '',
      articleSearch: ''
    };
  },
  methods: {
    getLegislationName(id) {
      const legislation = this.legislations.find(l => l.id === id);
      return legislation ? legislation.title : '';
    },
    addComment() {
      this.question.comments.push('');
    },
    removeComment(index) {
      this.question.comments.splice(index, 1);
    },
    async saveQuestion() {
      try {
        console.log('Quesito salvato:', this.question);
        try {
          await this.$root.$api.post('/questions/store', this.question);
          this.showSuccessToast('Complimenti', 'Quesito creato con successo');
          this.$router.push('/questions');
        } catch (error) {
          this.showErrorToast('Errore', 'Errore nel salvataggio del quesito')
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors
          } else {
            this.errors = { general: ['Si è verificato un errore durante la creazione del quesito'] }
          }
        }
      } catch (error) {
        this.showErrorToast('Errore', 'Errore durante la creazione del quesito');
        console.error(error);
      }
    },
    addTopic(event) {
      const id = parseInt(event.target.value);
      if (id && !this.question.topics.includes(id)) {
        this.question.topics.push(id);
      }
      event.target.value = ''; // reset select
    },
    removeTopic(index) {
      this.question.topics.splice(index, 1);
    },
    getTopicName(id) {
      const topic = this.availableTopics.find(t => t.id === id);
      return topic ? topic.title : '';
    },
    getArticleTitle(id) {
      const art = this.availableArticles.find(a => a.id === id);
      return art ? art.versions[0].title : `Articolo ${id}`;
    },
    removeArticle(index) {
      this.question.articles.splice(index, 1);
    }
  },
  watch: {
    'question.legislation_id': async function (newLegId) {
      this.question.articles = [];
      if (!newLegId) {
        this.availableArticles = [];
        return;
      }

      try {
        const response = await this.$root.$api.get('/articles/bylegislation', {
          params: { legislation_id: newLegId }
        });
        this.availableArticles = response.data;
      } catch (error) {
        this.showErrorToast('Errore', 'Impossibile caricare articoli per la legislazione selezionata');
      }
    }
  },
  computed: {
    remainingObjectChars() {
      return this.maxObjectLength - (this.question.object?.length || 0);
    },
    remainingTextChars() {
      return this.maxTextLength - (this.question.text?.length || 0);
    },
    selectedTopicsLabel() {
      if (this.question.topics.length === 0) return 'Seleziona argomenti';
      if (this.question.topics.length === 1) {
        const topic = this.availableTopics.find(t => t.id === this.question.topics[0]);
        return topic ? topic.title : '1 argomento';
      }
      return `Selezione multipla (${this.question.topics.length})`;
    },
    isFormValid() {
      return (
        this.question.object.trim().length > 0 &&
        this.question.text.trim().length > 0 &&
        this.question.topics.length > 0 &&
        this.question.articles.length > 0 &&
        this.question.legislation_id !== null
      );
    },
    selectedLegislationLabel() {
      if (!this.question.legislation_id) return 'Seleziona legislazione';
      const leg = this.legislations.find(l => l.id === this.question.legislation_id);
      return leg ? leg.title : 'Seleziona legislazione';
    },
    selectedArticlesLabel() {
      if (!this.question.articles || this.question.articles.length === 0) return 'Seleziona articoli';
      if (this.question.articles.length === 1) {
        const art = this.availableArticles.find(a => a.id === this.question.articles[0]);
        return art ? art.versions[0].title : '1 articolo';
      }
      return `Selezione multipla (${this.question.articles.length})`;
    },
    filteredTopics() {
      if (!this.topicSearch) return this.availableTopics;
      return this.availableTopics.filter(t =>
        t.title.toLowerCase().includes(this.topicSearch.toLowerCase())
      );
    },
    filteredArticles() {
      if (!this.articleSearch) return this.availableArticles;
      return this.availableArticles.filter(a =>
        a.versions[0].title.toLowerCase().includes(this.articleSearch.toLowerCase())
      );
    }
  },
  async mounted() {
    try {
      const topicsResponse = await this.$root.$api.get('/questions/topics');
      this.availableTopics = topicsResponse.data;
      this.legislations = Object.values(this.$root.dlgs || {});
    } catch (error) {
      this.showErrorToast('Errore', 'Impossibile caricare argomenti o legislazioni');
    }
  }
};
</script>

<style scoped>
.question-view {
  padding: 2rem;
}

.card {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(74, 108, 247, 0.15);
}

.input-group input {
  flex: 1;
}

.text-area-scroll {
  min-height: 200px;
  max-height: 400px;
  overflow-y: auto;
  resize: vertical;
  line-height: 1.4;
  white-space: pre-wrap;
}

.badge-wrap {
  white-space: normal;
  word-break: break-word;
  display: inline-block;
  max-width: 100%;
}
</style>